import React from 'react';
import { useAtomValue } from 'jotai';
import { Skeleton } from 'antd';

import { ScrollWrapper } from './styled';
import { chatStreamLoadingAtom, useNexaStore } from '../NexaStore';
import TypingIndicator from '../elements/TypingIndicator';
import Templates from '../Templates';
import { useScrollToBottom, useProcessedEvents, ProcessedNexaEvent } from './utils';

import EventRecord from './EventRecord';

const EventList = ({ isFetching }) => {
  const { events } = useNexaStore();
  const isStreaming = useAtomValue(chatStreamLoadingAtom);

  // scroll to bottom when events change
  const bottomRef = useScrollToBottom<HTMLDivElement>([events.length]);

  // Use the memoized hook to process events
  const processedEvents: ProcessedNexaEvent[] = useProcessedEvents(events, isStreaming);

  if (isFetching) {
    return (
      <ScrollWrapper>
        <Skeleton active />
      </ScrollWrapper>
    );
  }

  if (events.length === 0) {
    return (
      <ScrollWrapper>
        <Templates />
      </ScrollWrapper>
    );
  }

  return (
    <ScrollWrapper style={{ paddingBottom: 50 }}>
      {processedEvents.map((entry) => {
        const {
          id = '-',
          author,
          type,
          value,
          isLastAgentInSequence,
          isLastAgentEventOverall,
          thought,
          hasNonThoughtAfter,
          precedingUserQuery,
          functionCalls,
        } = entry;
        return (
          <EventRecord
            id={id}
            author={author}
            type={type}
            value={value}
            key={id}
            functionCalls={functionCalls}
            isLastAgentInSequence={isLastAgentInSequence}
            isLastAgentEventOverall={isLastAgentEventOverall}
            thought={thought}
            hasNonThoughtAfter={hasNonThoughtAfter}
            precedingUserQuery={precedingUserQuery}
          />
        );
      })}
      <TypingIndicator />
      <div ref={bottomRef} />
    </ScrollWrapper>
  );
};

/*
TODO: divider for dashboard links
{index < functionCallStack.current.length - 1 && <DashLinkDivider />}
*/

export default EventList;
